import { httpClient } from '@bcba/client-auth';

const basePath = '/public/sign-up';

export const getUrlFileFromAwsBySignupRequestUuid = async (uuid: string) => {
  const { data } = await httpClient.get<string>(
    `${basePath}/${uuid}/permission-document`,
  );

  return data;
};
